import { useState } from 'react';
import { ISendEmailRequest } from '@nkr/store/index';
import { Button, Glyphicon } from "react-bootstrap";
import EmailContainer from '@nkr/views/admin/email';
import Drawer from "rc-drawer";

interface IProps {
    show: boolean,
    actionType: number,
    drawerEmailParams: {
        mode: string;
        id: string;
        positions: string;
        deadline: string,
        useStreamlinedCancellation: number;
        realTimeSwapFailure: number;
        preselectReversal: number;
        prereversalResponsibles: string;
        extra: string;
    }
    onCancel: (actionType: number) => void,
    sendMatchOfferWithComments: (actionType: number, matchOfferType: number, dateTime: string, forceTargetSurgeyDates: boolean, request: ISendEmailRequest, testRecipientList: string[]) => void
}

interface IState { }

const SwapMatchOfferEmail = ({
    show,
    actionType,
    drawerEmailParams,
    onCancel,
    sendMatchOfferWithComments
}: IProps) => {
    const [container, setContainer] = useState<HTMLDivElement>(null);

    container: HTMLDivElement;

    const saveContainer = (container: HTMLDivElement) => {
        setContainer(container);
    };

    if (drawerEmailParams == null)
        return null;


    const emailParams = {
        ...drawerEmailParams,
        actionType,
        sourceMatchOffer: true,
        onCloseSidePanel: onCancel,
        sendMatchOfferWithComments
    };


    return (
        <Drawer
            width="49vw"
            placement="right"
            getContainer={() => container}
            open={show}
        >
            <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div style={{ padding: '10px 0px' }}>
                    <EmailContainer {...emailParams} />
                </div>

                <div className='text-center bg-info'>
                    <Button bsStyle='link' block onClick={() => onCancel(actionType)}>Close This View</Button>
                </div>
            </div>
        </Drawer>
    );
}

export default SwapMatchOfferEmail;